import { Nullable } from 'utils/types';
import { LocationData } from './LocationData.model';

export interface Plan {
  lineType: string;
  id: string;
  description: string;
  planType: string;
}

export enum BusinessType {
  TV = 'TV',
  FIJO = 'FIJO',
}

export type DeliveryDomicile = {
  accountNumberId: Nullable<string>;
  accountServiceStatus: Nullable<string>;
  accountType: Nullable<string>;
  acometido: Nullable<string>;
  addressCity: Nullable<string>;
  addressDepartment: Nullable<string>;
  addressFlat: Nullable<string>;
  addressFloor: Nullable<string>;
  domicile_id: Nullable<string>;
  addressNumber: Nullable<string>;
  addressObservations: Nullable<string>;
  addressStreet: Nullable<string>;
  addressTower: Nullable<string>;
  addressWithinStreets: Nullable<string>;
  business: Nullable<BusinessType>;
  cityId: Nullable<string>;
  clientAccountNumber: Nullable<string>;
  cmpId: Nullable<string>;
  cpa: Nullable<string>;
  id: Nullable<string>;
  latitude: Nullable<string>;
  linesQuantity: Nullable<number>;
  longitude: Nullable<string>;
  lote?: Nullable<string>;
  mainIpTvForSale: Nullable<string>;
  manzana?: Nullable<string>;
  optionalStreet: Nullable<string>;
  optionalStreetNumber: Nullable<string>;
  plans: Plan[];
  polygonId: Nullable<string>;
  product: Nullable<string>;
  provider: Nullable<string>;
  regionName: Nullable<string>;
  suburb: Nullable<string>;
  suspendedLines: boolean;
  technology: Nullable<string>;
  zipCode: Nullable<string>;
};

export interface AddressResponse {
  deliveryDomiciles: DeliveryDomicile[];
  domicileQuantity: number;
}

export type GetClientByAddressParams = {
  accountNumberId: Nullable<string>;
  addressCity: Nullable<LocationData>;
  addressFlat: Nullable<string>;
  addressFloor: Nullable<string>;
  domicile_id: Nullable<string>;
  addressNumber: Nullable<string>;
  addressStreet: Nullable<string>;
  addressTower: Nullable<string>;
  businessType: Nullable<string>;
  regionName: Nullable<LocationData>;
  suburb: Nullable<LocationData>;
};

export type ResearchSdsParams = GetClientByAddressParams & {
  isNew: Nullable<boolean>;
  flow: string;
  clientAddresses: Nullable<DeliveryDomicile[]>;
  clientDocument: {
    documentNumber: Nullable<string>;
    documentType: Nullable<string>;
  };
};
